import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const Page = ({ route, documentTitle }) => {
  const { t } = useTranslation();

  const section = route.section ?? "main";
  const breadcrumb = useSelector((state) =>
    state.layout.find((breadcrumb) => breadcrumb.section === section)
  );

  useEffect(() => {
    if (route.path === "/") {
      document.title = documentTitle;
    } else if (route.dynamicTitle) {
      document.title = `${documentTitle} - ${t(route.titleSuffix, {
        value: breadcrumb?.breadcrumbName,
      })}`;
    } else {
      document.title = `${documentTitle} - ${t(route.titleSuffix)}`;
    }
  }, [route, breadcrumb]);

  return route.component;
};

export default Page;
